export default {
  'ACCOUNT_LOCKED_FOR_TOO MANY_FAILED_ATTEMPTS!':
    'Your account is blocked because 5 times you failed to login. Please Reset Your Password to access the account',
  INCORRECT_PASSWORD: 'Wrong Password Entered',
  Third_failed_login_attempt:
    'Wrong Password Entered, Please click Forgot Password',
  Fourth_failed_login_attempt:
    'Wrong Password Entered. Please Reset Your Password before the account is blocked',
  NO_ACTIVE_OTP_REQUEST: `Token expired, silakan kirim ulang OTP`,
  REPEAT_PASSWORD: "New password can't be same as previous password",
  ALREADY_TAKEN: 'Phone number already registered in Lilla',
  USER_NOT_FOUND: 'Username/Email tidak terdaftar',
  'phone_no already taken': 'Phone number already taken',
  'username required': 'Username required',
  INVALID_PHONE_NUMBER: 'Invalid phone number',
  EMAIL_EXISTS: 'Email already exists',
  USERNAME_EXISTS: 'Username already exists',
  INVALID_EMAIL: 'Email invalid',
  SESSION_EXPIRED: 'Session Expired',
  MISSING_PARAMETER: 'Missing Parameter',
  USER_ALREADY_REMOVED: `Akun kamu tidak dapat diakses. Jika ini sebuah kesalahan, silahkan hubungi cs@sociolla.com`,
  OTP_MAXIMUM: 'Reach maximum OTP Request (5 Request / day)',
  PHONE_NUMBER_EXISTS: 'Phone number already exists!',
  'invalid registration hash': 'Invalid registration hash',
  REGISTER_FAILED: 'Register failed',
};
